import { render, staticRenderFns } from "./SuiteSettings.vue?vue&type=template&id=2370f9cc"
import script from "./SuiteSettings.vue?vue&type=script&lang=ts"
export * from "./SuiteSettings.vue?vue&type=script&lang=ts"
import style0 from "./SuiteSettings.vue?vue&type=style&index=0&id=2370f9cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports